import React, { useState } from "react";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

export const DismissibleMemo = ({ id, className = "", children, testId }) => {
  const storageKey = `hotto_dismissed_memo_${id}`;
  const [isVisible, setIsVisible] = useState(() => localStorage.getItem(storageKey) !== "1");

  const dismiss = () => {
    localStorage.setItem(storageKey, "1");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <Card className={`relative ${className}`} data-testid={testId}>
      <Button
        type="button"
        size="icon"
        variant="ghost"
        onClick={dismiss}
        className="absolute right-2 top-2 h-7 w-7 text-slate-500 hover:text-slate-900"
        title="Tutup memo"
        data-testid={`${testId}-close`}
      >
        <X className="h-4 w-4" />
      </Button>
      {children}
    </Card>
  );
};